import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICellExportForm, ICellExportResponse } from '@mode/notebooks/contract';

@Injectable({ providedIn: 'root' })
export class CellExportClientService {
  constructor(private http: HttpClient) {}

  public exportCell(exportCellForm: ICellExportForm) {
    const { accountToken, reportToken, notebookToken, cellToken, payload } = exportCellForm;
    return this.http.post<ICellExportResponse>(
      `/api/${accountToken}/reports/${reportToken}/notebooks/${notebookToken}/cells/${cellToken}/local_datasets`,
      {
        python_cell: {
          content: payload.content,
          content_type: payload.contentType,
          python_session: {
            token: payload.sessionToken,
          },
        },
        notebook_cell_local_dataset_name: payload.datasetName,
      }
    );
  }
}
